'use client';

import React, {FC, PropsWithChildren} from 'react';
import {usePathname, useSearchParams} from 'next/navigation';

import useNavigationHistory from '../../src/hooks/useNavigationHistory';

import {HistoryContext} from './context';

const HistoryProvider: FC<PropsWithChildren> = ({children}) => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const queryString = searchParams?.toString() ?? '';
  const params = Object.fromEntries(searchParams ?? new URLSearchParams());

  // Build the equivalent of `asPath` from app-router primitives
  const asPath = queryString ? `${pathname}?${queryString}` : pathname;
  const hostedSource = params.hosted_source ?? null;

  const history = useNavigationHistory({
    asPath,
    hostedSource,
    route: pathname,
  });

  return (
    <HistoryContext.Provider value={history}>
      {children}
    </HistoryContext.Provider>
  );
};

export default HistoryProvider;
